import React, { useCallback, useEffect } from 'react'
import { createSearchParams, useNavigate, useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { StatisticEntityName } from './StatisticEntityName'
import { DateTime } from 'luxon'
import { Entity, useStatisticParams } from './useStatisticParams'

const StatisticDisplay = React.lazy(() => loadComponent('statistic', 'StatisticDisplay'))

export function Statistic() {
    const navigate = useNavigate()

    const [config, setConfig, getQueryParams] = useStatisticParams()
    const { type, _id } = useParams()

    const onBreakdownDataClick = useCallback(
        (entity: Entity) => {
            const newContext = (config.context ?? []).concat([{ _id: _id as string, type: type as string }])
            const newParams = { ...config, breakdown: '', context: newContext }

            navigate({
                pathname: `/statistic/${entity.type}/${entity._id}`,
                search: `?${createSearchParams(getQueryParams(newParams))}`,
            })
        },
        [_id, config, getQueryParams, navigate, type],
    )

    const isConfigInvalid = Object.values(config).some((value) => value === null || value === undefined)

    useEffect(() => {
        if (isConfigInvalid) {
            setConfig({
                from: DateTime.now().startOf('day').toJSDate(),
                to: DateTime.now().endOf('day').toJSDate(),
                chart: 'bar',
                breakdown: '',
                cumulation: '',
                context: [],
            })
        }
    }, [isConfigInvalid, setConfig])

    return (
        <>
            {type && _id && !isConfigInvalid && (
                <>
                    <StatisticEntityName />
                    <StatisticDisplay
                        type={type}
                        id={_id}
                        config={config}
                        onChangeConfig={setConfig}
                        onBreakdownDataClick={onBreakdownDataClick}
                    />
                </>
            )}
        </>
    )
}
